import { Div } from '../../../base/components/native/div'

export const MainTitle = () => {

    const base = Div('Tell us what you want to create.')
    base.cssClass({
        margin: '100px auto 60px',
        fontFamily: 'Syne',
        fontSize: '48px',
        fontWeight: '700',
        color: '#fff',
        width: '430px',
        textAlign: 'center',
        '@media (max-width: 768px)': {
            fontSize: '36px',
            width: '324px',
            padding: '0 5px',
            margin: '60px auto 30px',
        }
    })

    return base
}